<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="auth1">By the same author:</p>
<p class="auth2"><em class="italic">Sea Eagles of Empire</em></p>
<p class="auth2"><em class="italic">Empire State: How the Roman Military Built an Empire</em></p>
<p class="auth2"><em class="italic">Septimius Severus in Scotland<a href="#/xhtml/02_Author#rfnintauth_*" id="fnintauth_*">*</a></em></p>
<p class="auth2"><em class="italic">Roman Legionaries</em></p>
<p class="auth2"><em class="italic">Ragstone to Riches</em></p>
<p class="auth2"><em class="italic">Julius Caesar: Rome’s Greatest Warlord</em></p>
<p class="auth2"><em class="italic">Old Testament Warriors</em></p>
<p class="auth2"><em class="italic">Pertinax: The Son of a Slave Who Became Roman Emperor<a href="#/xhtml/02_Author#rfnintauth_*">*</a></em></p>
<p class="auth2"><em class="italic">Romans at War</em></p>
<p class="auth2"><em class="italic">Roman Britain’s Missing Legion: What Really Happened to IX Hispana?<a href="#/xhtml/02_Author#rfnintauth_*">*</a></em></p>
<p class="auth2"><em class="italic">Roman Conquests: Britain<a href="#/xhtml/02_Author#rfnintauth_*">*</a></em></p>
<p class="auth2"><em class="italic">Ancient Greeks at War</em></p>
<p class="auth2"><em class="italic">Alexander the Great versus Julius Caesar<a href="#/xhtml/02_Author#rfnintauth_*">*</a></em></p>
<p class="auth3"><em class="italic"><a href="#/xhtml/02_Author#fnintauth_*" id="rfnintauth_*">*</a> Denotes titles in print with Pen &amp; Sword Books/Greenhill Books</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Author.vue?6e48587e